// App
export const moizeMaxSize = 1000
export const defaultUniqueIdentifier = 'id'
export const appUrlRoot = '/ui'
export const imageUrlRoot = `${appUrlRoot}/images`
export const loginUrl = `${appUrlRoot}/login`
export const loginWithCookieUrl = `${appUrlRoot}/pmkft/login`
export const loginWithSsoUrl = `${appUrlRoot}/ssologin`
export const resetPasswordThroughEmailUrl = '/reset/password'
export const resetPasswordUrl = `${appUrlRoot}${resetPasswordThroughEmailUrl}`
export const forgotPasswordUrl = `${appUrlRoot}/forgot_password`
export const activateUserUrl = `${appUrlRoot}/users/activate`
export const logoutUrl = `${appUrlRoot}/logout`
export const dashboardUrl = `${appUrlRoot}/kubernetes/dashboard`
export const ssoRedirectUrl = `/Shibboleth.sso/Login`
export const allKey = '__all__'
export const noneKey = '__none__'
export type TablePrefsParams = {
  visibleColumns?: string[]
  columnsOrder?: string[]
  rowsPerPage?: number
  orderBy?: string
  orderDirection?: 'asc' | 'desc'
}
export const listTablePrefs: Array<keyof TablePrefsParams> = [
  'visibleColumns',
  'columnsOrder',
  'rowsPerPage',
  'orderBy',
  'orderDirection',
]
export const uuidRegex = new RegExp(
  /^[0-9a-f]{8}-[0-9a-f]{4}-[1-5][0-9a-f]{3}-[89ab][0-9a-f]{3}-[0-9a-f]{12}$/,
  'i',
)
export const k8sPrefix = `${appUrlRoot}/kubernetes`
export const userAccountPrefix = `${appUrlRoot}/my-account`
export const pluginRoutePrefix = `${appUrlRoot}/:plugin`
export const helpUrl = `${k8sPrefix}/help/support`
export const helpUrlDefinition = `${k8sPrefix}/help/:tab`

export enum AppPlugins {
  MyAccount = 'my-account',
  Infrastructure = 'infrastructure',
  Kubernetes = 'kubernetes',
  KubeVirt = 'kubevirt',
  Metal3 = 'metal3',
  ArgoCD = 'argo-cd',
}
export const appPlugins = [
  AppPlugins.MyAccount,
  AppPlugins.Infrastructure,
  AppPlugins.Kubernetes,
  AppPlugins.KubeVirt,
  AppPlugins.Metal3,
  AppPlugins.ArgoCD,
]

export enum CustomerTiers {
  Enterprise = 'enterprise',
  Freedom = 'freedom',
  Growth = 'growth',
  OEM = 'oem',
}

export const CustomerTierLabels = {
  [CustomerTiers.Enterprise]: 'Enterprise',
  [CustomerTiers.Freedom]: 'Freedom',
  [CustomerTiers.Growth]: 'Growth',
  [CustomerTiers.OEM]: 'OEM',
}

export const ssoEnabledTiers = [CustomerTiers.Enterprise, CustomerTiers.OEM]
export const themeEnabledTiers = [CustomerTiers.Enterprise, CustomerTiers.OEM]

export enum ClusterCloudPlatforms {
  EKS = 'eks',
  AKS = 'aks',
  GKE = 'gke',
}

export const defaultGroupMappingId = 'idp1_mapping'

export const upgradeLinks = {
  [CustomerTiers.Freedom]: 'https://platform9.com/signup/growth/',
  [CustomerTiers.Growth]: 'https://platform9.com/pricing/request/',
}

export const planComparisonLink = 'https://platform9.com/pricing/comparison/'

export const onboardingAccessSetup = 'onboarding/api-access'
export const onboardingMonitoringSetup = 'onboarding/monitoring-enabled'
export const onboardingPodSetup = 'onboarding/pod-setup'

export const defaultEtcBackupPath = '/etc/pf9/etcd-backup'

// Errors
export const addError = 'ERR_ADD'
export const updateError = 'ERR_UPDATE'
export const deleteError = 'ERR_DELETE'
export const notFoundErr = 'ERR_NOT_FOUND'

// Documentation
export const pf9DocOrigin = 'https://platform9.com/docs'

// Ideas
export const pf9IdeasLink = 'https://ideas.platform9.com'

export enum LoadingGifs {
  BlueTiles = 'BlueTiles',
  BluePinkTiles = 'BluePinkTiles',
  Ellipsis = 'Ellipsis',
}

export const imageUrls = Object.freeze({
  logoPrimary: `${imageUrlRoot}/logo-color.png`,
  lightLogoPrimary: `${imageUrlRoot}/primary-logo-dark.svg`,
  lightManagementPane: `${imageUrlRoot}/management-plane-on-white.png`,
  darkLogoPrimary: `${imageUrlRoot}/primary-logo.svg`,
  darkManagementPane: `${imageUrlRoot}/management-plane.png`,
})

export const codeMirrorOptions = Object.freeze({
  mode: 'yaml',
})

/**
 * Default axios config
 * @type {object}
 */
export const defaultAxiosConfig = Object.freeze({
  // While headers here will apply for all requests, is important to remember that
  // some services like Openstack will require custom headers for specific methods
  // like "Content-Type": "application/json-patch+json" for PATCH
  headers: {
    common: {
      'Content-Type': 'application/json;charset=UTF-8',
    },
  },
  timeout: 120000,
})

// Misc
export const publicSlackLink = 'https://kplane.slack.com'
export const supportEmail = 'support-ft@platform9.com'
export const pmkftSignupLink = 'https://platform9.com/signup-flow/?sandbox=kubernetes'

export enum UserPreferences {
  FeatureFlags = 'featureFlags',
  Dashboard = 'dashboard',
  Cluster = 'cluster',
  Namespace = 'namespace',
  CloudProviders = 'cloudProviders',
  DefaultClusters = 'defaultClusters',
}

export enum GlobalPreferences {
  Theme = 'theme',
  CustomerExternalId = 'customer_external_uuid',
  FeatureFlags = 'featureFlags',
}

export interface GlobalFeatureFlags {
  isOnboarded?: boolean
}
